import { render, staticRenderFns } from "./nxDialog.vue?vue&type=template&id=282702d4&scoped=true&"
import script from "./nxDialog.vue?vue&type=script&lang=js&"
export * from "./nxDialog.vue?vue&type=script&lang=js&"
import style0 from "./nxDialog.vue?vue&type=style&index=0&id=282702d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282702d4",
  null
  
)

export default component.exports